import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'

//from material-ui
import CardActionArea from '@material-ui/core/CardActionArea'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import CardMedia from '@material-ui/core/CardMedia'

//mport Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Fab from '@material-ui/core/Fab'

//redux
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
//import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types'

//from antd
import { Menu, Dropdown, Icon, message, Tooltip } from 'antd'
import TextField from '@material-ui/core/TextField'
import { Upload } from 'antd'

import Button from '../../../components/uielements/button'
//action
import organizationActions from '../../../redux/organization/actions'

import styles from './styles'
class OrganiItem extends Component {
    state = {
        bossName: 'Chưa có Trưởng Phòng',
        loading: false,
    }
    _getNameOrganiById = (listAllUser, boss_id) => {
        if (boss_id) {
            const user = listAllUser.find(item => {
                return item.uid === boss_id
            })
            if (user) {
                this.setState({
                    bossName: user.display_name,
                })
            }
        }
        //return bossName
    }

    _showModelUser = () => {
        //console.log("showModalUsers")
        const { showModalUsers } = this.props
        showModalUsers()
    }
    componentWillReceiveProps(nextProps, prevProps) {
        //this._getNameOrganiById(nextProps.listAllUser, boss_id)
    }
    componentDidMount() {
        const { organization, listAllUser } = this.props
        this._getNameOrganiById(listAllUser, organization.boss_id)
        //get Url
        this.setState({
            imageUrl: organization.ext_data.avatarOrgani,
            //organization.ext_data.avatarOrgani
        })
        //dispath Action
    }

    getBase64 = (img, callback) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    handleChange = info => {
        let { organization, modalActionCreators } = this.props

        if (info.file.status === 'uploading') {
            this.setState({ loading: true })
            return
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            this.getBase64(info.file.originFileObj, imageUrl => {
                this.setState({
                    imageUrl,
                    loading: false,
                })

                const { create_avatar_organiztion } = modalActionCreators
                create_avatar_organiztion(info.file.originFileObj, organization)
            })
        }
    }

    beforeUpload = file => {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
            message.error('Ảnh Nên Có Dung Lượng Nhỏ Hơn 2MB!')
        }
        return isLt2M
    }

    _uploadImage = () => {
        const dummyRequest = ({ file, onSuccess }) => {
            setTimeout(() => {
                onSuccess("ok");
            }, 0);
        };

        const props = {
            customRequest: dummyRequest,
            onChange: this.handleChange,
            multiple: true,
        }
        return <Upload {...props}></Upload>
    }
    onClickRole = () => {
        return message.warning('Ban Chua Duoc Cap Quyen ')
    }

    render() {
        const {
            classes,
            onClickEdit,
            onClickInfo,
            organization,
            onClickDelete,
        } = this.props
        const roleOfUserInOrgani = this.props.roleOfUserInOrgani
        const { editOrgani, viewOrgani, deleteOrgani } = roleOfUserInOrgani

        return (
            <Card className={classes.card}>
                <CardActionArea>
                    <CardMedia
                        className={classes.media}
                        image={organization.ext_data.avatarOrgani}
                    />
                </CardActionArea>
                <CardContent
                    style={{
                        textAlign: 'center',
                        marginTop: 5,
                        height: 75,
                        marginBottom: 30,
                    }}
                >
                    <Grid
                        container
                        style={{
                            textAlign: 'center',
                            verticalAlign: 'center',
                            color: 'red',
                        }}
                    >
                        <Grid item md={12} xs={12} sm={12}>
                            <TextField
                                style={{
                                    color: 'red',
                                }}
                                id="outlined-read-only-input"
                                label="Tên Đơn Vị"
                                //defaultValue={this.state.bossName}
                                value={organization.name}
                                margin="normal"
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions
                    className={classes.cardActions}
                    style={{
                        marginTop: 10,
                        textAlign: 'center',
                        height: 50,
                        padding: 0,
                    }}
                >
                    {viewOrgani && (
                        <Fab
                            //color="primary"
                            aria-label="Info"
                            className={classes.fab}
                            size="small"
                            onClick={onClickInfo}
                            style={{
                                backgroundColor: '#1676c9',
                                color: 'white',
                            }}
                        >
                            <Icon type="info" />
                        </Fab>
                    )}
                    {editOrgani && (
                        <Fab
                            //color="primary"
                            aria-label="Edit"
                            className={classes.fab}
                            size="small"
                            onClick={onClickEdit}
                            style={{
                                backgroundColor: '#2ca332',
                                color: 'white',
                            }}
                        >
                            <Icon type="edit" />
                        </Fab>
                    )}
                    {deleteOrgani && (
                        <Fab
                            //color="secondary"
                            aria-label="Delete"
                            className={classes.fab}
                            size="small"
                            onClick={onClickDelete}
                            style={{
                                backgroundColor: '#e31426',
                                color: 'white',
                            }}
                        >
                            <Icon type="delete" />
                        </Fab>
                    )}
                </CardActions>
            </Card>
        )
    }
}

const mapStateToProps = state => {
    return {
        organizations: state.organization.organizations,
        roleOfUserInOrgani: state.organization.roleOfUserInOrgani,
        listAllUser: state.user.users,
        ...state.app,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        modalActionCreators: bindActionCreators(
            organizationActions.action,
            dispatch
        ),
    }
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default compose(
    withConnect,
    withStyles(styles)
)(OrganiItem)
